import googleUrl from "@/assets/images/google.svg";
import { Button, Text, Title } from "@mantine/core";
import { useEffect } from "react";
import { Link, useSearchParams } from "react-router";

export function Register() {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleGoogleLogin = () => {
    const webUrl = import.meta.env.VITE_WEB_URL;
    window.open(`${webUrl}/sso/google/redirect`);
  };

  useEffect(() => {
    const plan = searchParams.get("plan");
    const type = searchParams.get("type");

    if (plan && type) {
      sessionStorage.setItem("subscription_plan", plan);
      sessionStorage.setItem("subscription_type", type);
      setSearchParams({});
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className="mx-auto grid w-[350px] gap-5">
      <div className="grid gap-2 text-center">
        <Title order={1}>PhotoFuse</Title>
      </div>

      <Button
        type="button"
        onClick={handleGoogleLogin}
        variant="outline"
        size="md"
      >
        <img src={googleUrl} alt="Google" width="16" className="mr-2" />
        Sign up with Google
      </Button>

      <Text ta="center">
        Already have an account?{" "}
        <Link to="/auth/login" className="underline">
          Sign in
        </Link>
      </Text>
    </div>
  );
}
